import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ViolationTicketDashboardPage" */
	'pages/vehicle/ViolationTicket/ViolationTicketDashboardPage'));

export default [{ component, exact: true, path: '/violation_tickets/:violationTicketId' }];